/**
 * getContent
 *  获取自定义字段 Example 的展示信息
 *  @param {object} field - 当前字段的数据
 **/
const getContent = (field) => {
	const { fieldValue = '{}' } = field;
	const { text = '' } = JSON.parse(fieldValue);
	return text;
};

export default getContent;
